

























































import { AdminSiteManagementDefaultDevice } from '@/constants/admin-site-management'
import { AdminSiteManagementDeviceTypes } from '@/constants/admin-site-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isInitialLoading: true,
      isSavingData: false,
    }
  },

  computed: {
    deviceTypes() {
      return [
        AdminSiteManagementDeviceTypes.Tracker,
        AdminSiteManagementDeviceTypes.CommonGateway,
        AdminSiteManagementDeviceTypes.Scale,
        AdminSiteManagementDeviceTypes.PulseOximeter,
        AdminSiteManagementDeviceTypes.Thermometer,
        AdminSiteManagementDeviceTypes.BloodPressureMonitor,
        AdminSiteManagementDeviceTypes.Glucometer,
        AdminSiteManagementDeviceTypes.Inhaler,
        AdminSiteManagementDeviceTypes.PcrMachine,
      ]
    },
  },

  async mounted(): Promise<void> {
    this.isInitialLoading = false
    this.emitValidStatus()
  },
  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },

  methods: {
    addDeviceRow() {
      this.devices.push({
        ...AdminSiteManagementDefaultDevice,
        deviceIndex: this.devices.length,
      })
      this.emitDevicesAndValidStatus()
    },
    availableDeviceTypes(selectedType) {
      return this.deviceTypes.filter(dt => {
        return selectedType || this.devices.filter(dta => dta.type === dt).length === 0
      })
    },
    isValid() {
      return this.devices.length > 0 && this.devices.filter(d => !d.type).length == 0
    },
    emitValidStatus() {
      console.log('emitValidStatus(): ' + this.isValid())
      return this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.isValid(),
      })
    },
    emitDevices() {
      return this.$emit('setDevicesToAdd', this.devices)
    },
    emitDevicesAndValidStatus() {
      this.emitDevices()
      return this.emitValidStatus()
    },
  },
}
